const groupsTabStyles = (theme) => ({
  container: {
    padding: theme.spacing(3),
  },
  header: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
  },
  tableContainer: {
    marginTop: theme.spacing(2),
  },
  actionButtons: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  stageInfo: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: '#f5f5f5',
    borderRadius: theme.spacing(1),
  },
  gamedaysCell: {
    paddingTop: 0,
    paddingBottom: 0,
    backgroundColor: '#f8f9fa',
  },
  gamedaysContainer: {
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(6),
    borderLeft: `3px solid ${theme.palette.primary.main}`,
    marginLeft: theme.spacing(2),
  },
  gamedayItem: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    gap: theme.spacing(1),
    borderRadius: theme.spacing(0.5),
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:last-child': {
      marginBottom: 0,
    },
  },
  gamedayChip: {
    marginLeft: theme.spacing(1),
  },
  expandButton: {
    transition: 'transform 0.2s',
  },
  groupRow: {
    cursor: 'pointer',
  },
})

export default groupsTabStyles
